// extracted by mini-css-extract-plugin
module.exports = {"choice-categories":"ChoiceCategories_choice-categories__VdtRo"};